module.exports = __webpack_public_path__ + "img/右太极.b4c926c6.gif";